import { EditorState, ContentState } from 'draft-js';

//  clear input and move caret to the end, allow user to undo the message
export const clearTextInput = (editorState: any) => {
  const emptyState = EditorState.push(
    editorState,
    ContentState.createFromText(''),
    'remove-range',
  );

  return EditorState.moveFocusToEnd(emptyState);
};
